<template>
  <div class="loading" v-if="pending">
    <v-progress-linear
      height=2
      color="accent"
      indeterminate
    ></v-progress-linear>
  </div>
  <div v-else>
    {{ value || '—' }}
  </div>
</template>

<script>
export default {
  data () {
    return {
      pending: true,
      value: null
    }
  },
  props: {
    fetch: Function
  },
  created () {
    this.fetch()
      .catch(() => null)
      .then((data) => {
        this.value = data
        this.pending = false
      })
  }
}
</script>

<style lang="scss" scoped>
.loading {
  width: 20px
}
</style>
